"use client";

import React from "react";
import { FiClipboard, FiExternalLink } from "react-icons/fi";
import styles from "./TaskCardList.module.css";
import { useTasks } from "./useTasks";
import { getTaskId } from "./utils";
import TaskCard from "./TaskCard";
import TaskCardSkeleton from "./TaskCardSkeleton";

const LatestTasks: React.FC = () => {
  const { tasks, isFirstLoad, newItemId } = useTasks();

  return (
    <div className={styles.containerNoBg}>
      <div className={styles.header}>
        <h3 className={styles.title}><FiClipboard size={18} /> Latest tasks</h3>
        <a
          href="https://management.opengpu.network/tasks"
          className={styles.viewAll}
          target="_blank"
          rel="noopener noreferrer"
        >
          View all tasks <FiExternalLink size={14} />
        </a>
      </div>
      <div
        className={`${styles.cardListVertical} ${isFirstLoad ? "" : styles.fadeIn}`}
      >
        {tasks.length > 0
          ? tasks.map((task) => (
              <TaskCard
                key={getTaskId(task._id)}
                task={task}
                isNew={getTaskId(task._id) === newItemId}
              />
            ))
          : Array.from({ length: 5 }).map((_, i) => (
              <TaskCardSkeleton key={i} />
            ))}
      </div>
    </div>
  );
};

export default LatestTasks;
